import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Idaho = () => {
  return (
    <StatePropertyTaxPage
      stateName="Idaho"
      processDescription="Appeals must be submitted to the County Board of Equalization on or before the fourth Monday in June. Written protests may be filed in person, by mail, or electronically using county-provided forms."
      noticeOfValueMailed="Early June"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed the first week of June, but may vary slightly by county."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Idaho Code § 63-205 requires property to be assessed based on its market value as of January 1 each year. This standardized assessment date ensures consistent property valuations across all counties in Idaho."
      deadlineExplanation="Property owners must file protests by the fourth Monday in June. In 2025, this date falls on June 23. Written protests may be submitted in person, by mail, or electronically using county-provided forms. This deadline is strictly enforced across all Idaho counties."
    />
  );
};

export default Idaho;